import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import AppBar from '@material-ui/core/AppBar';
import { FormControl, Select, MenuItem, Divider, FormControlLabel, Switch } from '@material-ui/core';
import { Tooltip } from '@material-ui/core'
import { RotateLeft } from '@material-ui/icons'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import './styles/sign-dialog.scss';
import '../styles/sign.scss';
import { useMutation, useQuery } from '@apollo/react-hooks';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Moment from 'react-moment';
import { GET_SIGN_IMAGE_CONTENTS, SWITCH_PROGRAM, GET_SIGN_STATE, RESET_RGB } from './queries/sign-dialog.queries';
import { UrlasserDialog } from '../../../dialogs';
import { CitizensBandRadio, SignImageContent } from '..';
import DisplayContent from '../DisplayContent';


import gql from 'graphql-tag'
import { useParams } from 'react-router-dom';
import checkAuthorization from '../../../Authorization/Authorization';
const GET_CURRENT_USER = gql`
query {
    currentUser {
      id
      username
      name
      accessAuthorizations{
        id
        canPerformActions
      }
    }
}
`;

const GET_PROJECT = gql `
query central($id: String!){
    central(id: $id){
      id
      project_id
    }
  }
`;


const useStyles = makeStyles(() => ({
  title: {
    flexGrow: 1,
  },
  root: {

  },
  contentArea: {
    minHeight: '340px',
    maxHeight: '380px',
  },
  switchModeArea: {
    paddingTop: '15px',
    paddingBottom: '15px',
  }
}));

const SignDetailDialog = ({
  source, open, onClose, onVerifyClick,
}) => {
  const classes = useStyles();
  const [openUrlasserDialog, setOpenUrlasserDialog] = React.useState(false);
  const [tabValue, setTabValue] = React.useState(0);
  const [selectedImage, selectImage] = React.useState(false);
  const [manualSwitchMode, setManualSwitchMode] = React.useState();
  const [switchProgram] = useMutation(SWITCH_PROGRAM);
  const { data: imageContentResultData, refetch } = useQuery(GET_SIGN_IMAGE_CONTENTS, { variables:{ id: source.id } });
  let hasBlinkingLights = false;
  const [blinkingLightsState, setBlinkingLightsState] = React.useState();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleSwitchModeChange = (name) => (event) => {
    setManualSwitchMode(event.target.checked);
  };

  function handleImageSelect(image) {
    selectImage(image);
  }

  function handleClose() {
    selectImage(null);
    onClose();
  }


  function a11yProps(index) {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    };
  }

  if (source && source.blinking_lights !== null) {
    hasBlinkingLights = source.blinking_lights !== null;
  }

  let imageContents = [];
  if (imageContentResultData) {
    imageContents = imageContentResultData.device.image_contents;
    
  }

  if (!selectedImage || selectedImage === null) {
    if (imageContentResultData) {
      if (imageContentResultData.device.sign_command){
        handleImageSelect(imageContentResultData.device.sign_command.program);
        const program_state = imageContentResultData.device.sign_command.program_state;
        if (program_state === 2) {
          setManualSwitchMode(true);
        }
      }

      if (hasBlinkingLights) {
        let blinkingLightsCommand = imageContentResultData.device.blinking_lights.blinking_lights_command;
        if (blinkingLightsCommand){
          if(blinkingLightsCommand.program_state !== 2) {
            setBlinkingLightsState("auto");
          } else {
            setBlinkingLightsState(blinkingLightsCommand.program);
          }
        } 
      }
    }
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
      >
        <div className="tabPanel">{children}</div>
      </Typography>
    );
  }

  const handleUrlasserDialogClose = () => {
    setOpenUrlasserDialog(false);
  };

  const handleBlinkingLightsSelectChange = name => event => {
    setBlinkingLightsState(event.target.value);
  };



  /////////////////////////////////////////////////////////////////////////////////////////////////////
  const {centralID} =useParams()
  
  const { data: currentUserData } = useQuery(GET_CURRENT_USER, { fetchPolicy: "cache-first" });
  const { data: currentProject } = useQuery(GET_PROJECT, {variables:{id: centralID}})
  const [command, setCommand] = useState('')
  const [resetRGB] = useMutation(RESET_RGB)
  
  function handleResetClicked() {
    checkAuthorization(
      currentUserData, 
      currentProject, 
      document.getElementById('authentication_problem'),
      () => {setCommand('reset');setOpenUrlasserDialog(true)})
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////

  function handleUrlasserDialogVerifyClick(username, cause, initiator) {

    try {
      if(command === 'reset'){
        resetRGB({ variables: {id: source.id, cause, initiator} })
        setCommand('')
      }else{
        let programs = [];
        programs.push({device_id: source.id, program: manualSwitchMode ? selectedImage : null});
        if (hasBlinkingLights) {
          programs.push({device_id: source.blinking_lights.id, program: blinkingLightsState === 'auto' ? null : blinkingLightsState});
        }
        switchProgram({ variables: {programs, cause, initiator} });
        refetch();
      }
      
    } catch (err) {
      console.log(err);
    }
    setOpenUrlasserDialog(false);
    onVerifyClick();
  }

  const handleVerifyClicked = () => {
    checkAuthorization(
      currentUserData, 
      currentProject, 
      document.getElementById('authentication_problem'),
      () => {setOpenUrlasserDialog(true)}
    )

  };

  return (
    <>
      {openUrlasserDialog ? (
        <UrlasserDialog
          onVerifyClick={handleUrlasserDialogVerifyClick}
          onClose={handleUrlasserDialogClose}
          open={openUrlasserDialog}
        />
      ) : <></>}
      <Dialog 
        className={classes.root}
        scroll="paper"
        autoDetectWindowHeight
        autoScrollBodyContent
        maxWidth="md"
        fullWidth
        open={open}
        onClose={handleClose}>
        <AppBar position="static" color="primary">
          <Toolbar>
            <div className={classes.title}><Typography variant="h5">{source.name}</Typography></div>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <AppBar position="static" color="default">
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="sign detail dialog tabs">
            <Tab label="Allgemein" {...a11yProps(0)} />
            <Tab label="Live-Daten" {...a11yProps(1)} />
          </Tabs>
        </AppBar>
        <DialogContent className={classes.contentArea}>
          {/*--------------------------------------------------------------------------------------------------------------------------------------------*/}
          <TabPanel classes={classes} value={tabValue} index={0}>
            {hasBlinkingLights
              ? (
                <>
                  <div className="blinkingLightsSettings">
                    <Typography variant="body1" className="label">Blinklampenbefehl</Typography>
                    <BlinkingLightsSelect value={blinkingLightsState} onChange={handleBlinkingLightsSelectChange(source.blinking_lights.id)} />
                  </div>
                  <Divider />
                </>
              ):<></>
            }
            <div>
              <div className={classes.switchModeArea}>
                <FormControlLabel
                  checked={manualSwitchMode}
                  value="manualSwitchMode"
                  onChange={handleSwitchModeChange()}
                  control={<Switch color="primary" />}
                  label="Manuelle Schaltung aktivieren?"
                  labelPlacement="start"
                />
              </div>
              {/* <Divider/> */}
              <div className={manualSwitchMode ? "imageContentArea":"imageContentArea disabled"}>
                {imageContents !== null && imageContents.map(item => {
                  return (
                    // <div className='device-inner'>
                    <div key={item} onClick={() => handleImageSelect(item)} className={selectedImage === item ? "imageContent selected":"imageContent"}> 
                      <DisplayContent contentID={item} ID={source.id} signType={source.sign_type}/>
                    </div>)
                })}
              </div>
            </div>
          </TabPanel>
          <TabPanel classes={classes} value={tabValue} index={1}>           
            <LiveDataTable signId={source.id} signType ={source.sign_type}/>
          </TabPanel> 
          {/*--------------------------------------------------------------------------------------------------------------------------------------------*/}                
        </DialogContent>
        <Divider/>
        <DialogActions className="deviceDialogActions">
          { source.sign_type ==="MATRIXRGB_64_X_96" &&
            <Tooltip placement="top" title="Reset">
              <IconButton
                color="primary"
                onClick={handleResetClicked}
                className="resetButtonRGB"
              >
                <RotateLeft className="icon"/>
              </IconButton>
            </Tooltip>
          } 
          <p id= 'authentication_problem' style={{color:'red', marginLeft:'10px'}}></p>  
          <Button color="primary" onClick={handleClose}>Abbrechen</Button>
          <Button color="primary" variant="contained" onClick={handleVerifyClicked}>Übernehmen</Button>
        </DialogActions>
      </Dialog>
      </>
    );
};

const BlinkingLightsSelect = props => {
  const { value, onChange } = props;
  return (<FormControl>
    <Select className="programSelect"
      value={value}
      onChange={onChange}
    >  
        <MenuItem key={0} value={"auto"}>
          <span>Automatik</span>
        </MenuItem>
        <MenuItem key={1} value={"Dunkel"}>
          <span>Aus</span>
        </MenuItem>
        <MenuItem key={2} value={"TLS.GelbesBlinklicht"}>
          <span>An</span>
        </MenuItem>          
    </Select>
  </FormControl>)
};

function convertProgramStateToString(programState) {
  if (programState === 0) {
    return 'Automatikprogramm';
  } if (programState === 1) {
    return 'Sonderprogramm';
  } if (programState === 2) {
    return 'Handprogramm';
  } if (programState === 3) {
    return 'Vorortbetrieb';
  }
  return 'N/A';
}

function convertOperatingModeToString(operatingMode) {
  if (operatingMode === 0) {
    return 'Normalbetrieb';
  } if (operatingMode === 1) {
    return 'Blindbetrieb';
  }
  return 'N/A';
}


const LiveDataTable = props => {
  const { signId, signType } = props;
  console.log(signType)
  const { data } = useQuery(GET_SIGN_STATE, { variables: { id: signId } });
  let errorState = 'N/A';
  let signState = { program: '', program_state: -4 };
  let programState = 'N/A';
  let signCommand = { program: '', program_state: -4 };
  let commandProgramState = 'N/A';
  let clusterState = {};
  let ambientBrightness = {};
  let doorContactState = { open: 'N/A' };
  let operatingMode = 'N/A';

  if (data) {
    if (data.device.sign_state !== null) {

      signState = data.device.sign_state;
      programState = convertProgramStateToString(signState.program_state);

      signCommand = data.device.sign_command;
      commandProgramState = convertProgramStateToString(signCommand.program_state);

      if (data.device.cluster !== null && data.device.cluster !== undefined) {
        if (data.device.cluster.cluster_state !== null && data.device.cluster.cluster_state !== undefined) {
          clusterState = data.device.cluster.cluster_state;
        }
      }

      if (data.device.ambient_brightness !== null && data.device.ambient_brightness !== undefined) {
        ambientBrightness = data.device.ambient_brightness;
      }

      doorContactState.open = 'N/A';
      if (data.device.door_contact_state !== null && data.device.door_contact_state !== undefined) {
        if (data.device.door_contact_state.open === 1) {
          doorContactState.open = 'ja';
        } else if (data.device.door_contact_state.open === 0) {
          doorContactState.open = 'nein';
        } else {
          doorContactState.open = 'N/A';
        }
      }

      if(signState.error_state === 0) {
        errorState = 'OK';
      } else if(signState.error_state === 1) {
        errorState = 'Gestört';
      } else if(signState.error_state === 2) {
        errorState = 'Teilstörung';
      } else if(signState.error_state === 3) {
        errorState = 'Kommunikationsausfall';
      }

      if(signState.error_state > 3 || signState.error_state < 0) {
        errorState = 'N/A';
      }
      
      operatingMode = convertOperatingModeToString(clusterState.operating_mode);
    }

    return (
      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell>{ signType==='CitizensBandRadio'?'Ansagetext':'Bildinhalt'}</TableCell>
            <TableCell>{signState.program}</TableCell>
            <TableCell><Moment format="DD.MM.YYYY HH:mm:ss">{signState.timestamp}</Moment></TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Programmstatus</TableCell>
            <TableCell>{programState}</TableCell>
            <TableCell><Moment format="DD.MM.YYYY HH:mm:ss">{signState.timestamp}</Moment></TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Status</TableCell>
            <TableCell>{errorState}</TableCell>
            <TableCell><Moment format="DD.MM.YYYY HH:mm:ss">{signState.timestamp}</Moment></TableCell>
          </TableRow>

          <TableRow>
            <TableCell>{ signType==='CitizensBandRadio'?'Ansagetext (Befehl)':'Bildinhalt (Befehl)'}</TableCell>
            <TableCell>{signCommand.program}</TableCell>
            <TableCell><Moment format="DD.MM.YYYY HH:mm:ss">{signCommand.timestamp}</Moment></TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Programmstatus (Befehl)</TableCell>
            <TableCell>{commandProgramState}</TableCell>
            <TableCell><Moment format="DD.MM.YYYY HH:mm:ss">{signCommand.timestamp}</Moment></TableCell>
          </TableRow>

          { signType !== 'CitizensBandRadio' && signType !== 'HYBRID_64_X_64' && <TableRow>
            <TableCell>Umgebungshelligkeit</TableCell>
            {ambientBrightness.brightness < 0
              ? <TableCell>N/A</TableCell> : (
                <TableCell>
                  {ambientBrightness.brightness}
                  {' '}
                  Lx
                </TableCell>
              )}
            <TableCell><Moment format="DD.MM.YYYY HH:mm:ss">{ambientBrightness.timestamp}</Moment></TableCell>
          </TableRow>}

          { signType !== 'CitizensBandRadio' && <TableRow>
            <TableCell>Anzeigehelligkeit</TableCell>
            {clusterState.brightness < 0
              ? <TableCell>N/A</TableCell> : (
                <TableCell>
                  {clusterState.brightness}
                  {' '}
                  %
                </TableCell>
              )}
            <TableCell><Moment format="DD.MM.YYYY HH:mm:ss">{clusterState.timestamp}</Moment></TableCell>
          </TableRow>}

          <TableRow>
            <TableCell>Betriebsart</TableCell>
            <TableCell>{operatingMode}</TableCell>
            <TableCell><Moment format="DD.MM.YYYY HH:mm:ss">{clusterState.timestamp}</Moment></TableCell>
          </TableRow>


          { signType !== 'CitizensBandRadio' && signType !== 'HYBRID_64_X_64' && <TableRow>
            <TableCell>Tür geöffnet</TableCell>
            <TableCell>{doorContactState.open}</TableCell>
            <TableCell><Moment format="DD.MM.YYYY HH:mm:ss">{doorContactState.timestamp}</Moment></TableCell>
          </TableRow>}

        </TableBody>
      </Table>
    );
  }
  return null;
};

SignDetailDialog.propTypes = {
  source: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onVerifyClick: PropTypes.func.isRequired,
};

export default SignDetailDialog;
